import React, { useState, useEffect } from "react";
import "./product1.css";
import App1 from "./product2.js";
import Footer from "./footer";
import { Link } from "react-router-dom";
import Header1 from "./header1";

const AppContainer = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [showVideo, setShowVideo] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");

  const openVideo = (src) => {
    setShowVideo(true);
    setVideoSrc(src);
  };

  const closeVideo = () => {
    setShowVideo(false);
    setVideoSrc("");
  };

  const videoSources = {
    firstVideo: "sp.mp4",
    secondVideo: "",
    thirdVideo: "EdXAR short Promo.mp4",
    // Add more video sources as needed
  };

  const [showImage, setShowImage] = useState(false);
  const [imageSrc, setImageSrc] = useState("");

  const openImage = (src) => {
    setShowImage(true);
    setImageSrc(src);
  };

  const closeImage = () => {
    setShowImage(false);
    setImageSrc("");
  };


  return (
    <div>
      <div className="header1">
        <Header1 />
      </div>
      <div className="rectangle-roots">
        <a href="/">
        <p className='titlename2'>VREON TECH INDIA PVT LTD</p>

        </a>
        <div className="frame-items" />
        <div className="frame-inners" />

        <div className="rectangle-groups">
          <div className="rectangle-divs" />

          <b className="home2s">
            <Link to="/">HOME</Link>{" "}
          </b>
          <b className="about2s">
            <Link to="/about">ABOUT</Link>
          </b>
          <b className="service1s">
            <Link to="/service">SERVICES</Link>
          </b>
          <b className="portfolio2sf">
            <Link to="/portfolio">PORTFOLIO</Link>
          </b>

          <b className="contact1sf">
            <Link to="/contact">CONTACT</Link>
          </b>

          <a href="/">
          <img className="logo-1-icon1s" alt="" src="/logo.png" />
          </a>

          <b className="our-products1s">
            <Link to="/products">PRODUCTS</Link>
          </b>
        </div>
        <div className="rectangle-icons" />

        <div className="our-products2"> AR/VR PRODUCTS</div>

        <div className="view-demos">
          <a href="javascript:void(0)" onClick={() => openVideo(videoSources.firstVideo)}>VIEW</a>
        </div>
        {showVideo && videoSrc === videoSources.firstVideo && (
          <div className="video-overlays">
            <div className="video-containers">
              <iframe
                title="Demo Video"
                width="500"
                height="300"
                src={videoSources.firstVideo}
                frameborder="0"
                allowfullscreen
              ></iframe>
              <button className="close-buttons" onClick={closeVideo}>
                Close
              </button>
            </div>
          </div>
        )}

        <div className="view-demo1s" >
          <a href="javascript:void(0)" onClick={() => openVideo(videoSources.secondVideo)}>VIEW</a>
          
        </div>
        {/* {showVideo && videoSrc === videoSources.secondVideo && (
          <div className="video-overlay1s">
            <div className="video-container1s">
              <iframe
                title="Demo Video"
                width="500"
                height="300"
                src={videoSources.secondVideo}
                frameborder="0"
                allowfullscreen
              ></iframe>
              <button className="close-button1s" onClick={closeVideo}>
                Close
              </button>
            </div>
          </div>
        )} */}


        <div className="view-demo2s" >
          <a href="javascript:void(0)" onClick={() => openVideo(videoSources.thirdVideo)}>VIEW</a>
        </div>
        {showVideo && videoSrc === videoSources.thirdVideo && (
          <div className="video-overlay2s">
            <div className="video-container2s">
              <iframe
                title="Demo Video"
                width="500"
                height="300"
                src={videoSources.thirdVideo}
                frameborder="0"
                allowfullscreen
              ></iframe>
              <button className="close-buttons" onClick={closeVideo}>
                Close
              </button>
            </div>
          </div>
        )}

        <div className="our-productss">{`.`}</div>

        <div className="logo-1-icon2s"><img className="edxarimg" src="EDXAR Logo.png"></img></div>
        <div className="logo-3-icons"><img className="scienceparkimg" src="science park.png"></img></div>
        <div className="logo-2-icons"><img className="arimg" src="jewellar.png"></img></div>

        <div className="logo-1-icon2sS">EdXAR us an innovative Extended Reality (AR/VR) tech educational app developed by VREON Tech India that provides users with an immersive and interactive learning experience. Our platform integrates the physical and digital realms tarough VISION BOOKS thereby enhancing education to be engaging, enjoyable, equitable and experiential for all.</div>
        <div className="logo-3-iconsS">Science Park is  Virtual Reality Technology (VR) based movies for 10 mins. It provides VR entertainment for school children. It includes Jungle Safari (ride inside a forest),Jurassic Park(About Dinosaurs),Space Ride (travelling in Space) & Underwater (life under sea water) each of 10 minutes. </div>
        <div className="logo-2-iconsS">JevelAR is based on Augmented Reality (AR) technology which provides an innovative shopping experience to customers. This allows each user to view virtually and try jevels experience the latest designs before purchase. The product provides an immersive and engaging experience. </div>


        <div className="edxar-is-ans">
          <a href="SIZE SETTING EDXAR 2.png" onClick={() => openImage("SIZE SETTING EDXAR 2.png")}>

          </a>
          {/* {showImage && imageSrc && (
    <div className="image-overlay">
      <div className="image-container">
    
        <img src={imageSrc} alt="Experience Image" />
        <div className="close-container">
          <button className="close-buttonsG" onClick={closeImage}>
            Close
          </button>
        </div>
      </div>
    </div>
  )} */}
        </div>

        <div className="built-on-augmenteds" onClick={() => openImage("SIZE SETTING EDXAR 2.png")}>
          <a href="SIZE SETTING EDXAR 1.png"></a>
        </div>
        <div className="built-on-augmented1s" onClick={() => openImage("SIZE SETTING EDXAR 2.png")}>
          <a href="SIZE SETTING EDXAR 1.png"></a>
        </div>

        <div className="product2">
          <App1 />
        </div>

      </div>
      <Footer />
    </div>
  );
}

export default AppContainer;
